import React, { useState, useEffect, memo } from "react";

import styles from "./index.module.less";
import ServiceSearch from "../../../ServiceSearch";
import { Iprops } from "../..";
import { APP_NAME } from "@/config/name";
const Header = ({ onAppOrLinkClick, t }: Iprops) => {
  return (
    <div className={styles["header_wrapper"]}>
      <div className={styles["header_title"]}>
        {t("homeIndex.title", {
          appName: APP_NAME
        })}
      </div>

      <ServiceSearch placeholder={t("homeIndex.search-tips")} onAppOrLinkClick={onAppOrLinkClick} />
    </div>
  );
};
export default Header;
